export const DASHBOARD = "DASHBOARD"

export const DASHBOARD_DATA = "DASHBOARD_DATA"
